export default {
      id: "drivers-score-card-usage",
      viewBox: "0 0 26 15",
      url: __webpack_public_path__ + "img/icons.svg#drivers-score-card",
      toString: function () {
        return this.url;
      }
    }